import { render, staticRenderFns } from "./ExhibitorFavoriter.vue?vue&type=template&id=7071ff08&"
import script from "./ExhibitorFavoriter.vue?vue&type=script&lang=js&"
export * from "./ExhibitorFavoriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports